<script>
  export let element = "jump.salchow";
  import { _ } from "svelte-i18n";
  const levelElements = [
    "jump.salchow",
    "jump.loop",
    "jump.flip",
    "jump.toeloop",
    "jump.lutz",
    "jump.axel",
    /*
    "spinn.upright",
    "spinn.sit",
    "spinn.camel",
    "spinn.jump",
    "spinn.layback",
    "spinn.combination",
*/
  ];
  const durationOnly = [
    "FigureSkating.TechniqueSteps",
    "FigureSkating.BaseTraining",
    "general.game1",
    "general.game2",
  ];
  export let repetitions = undefined;
  export let successful = undefined;
  export let level = "2";
  export let content = undefined;
  export let duration = undefined;
  let visible = true;

  function remove() {
    visible = false;
    repetitions = "removed";
  }
</script>

{#if visible}
  <div class="form-subsection">
    <button
      type="button"
      on:click={remove}
      class="form-subsection__button-remove"
    />
    <div class="">
      <label class="select" for="tag-group">
        <span class="select__label">{$_("sessions.form.iceTraining.title")}</span>
        <span class="select__button">
          <select bind:value={element}>
            <option hidden="" />
            <optgroup label={$_("sessions.form.iceTraining.techniques.jump.title")}>
              <option value="jump.salchow">{$_("sessions.form.iceTraining.techniques.jump.salchow")}</option>
              <option value="jump.loop">{$_("sessions.form.iceTraining.techniques.jump.loop")}</option>
              <option value="jump.flip">{$_("sessions.form.iceTraining.techniques.jump.flip")}</option>
              <option value="jump.toeloop">{$_("sessions.form.iceTraining.techniques.jump.toeLoop")}</option>
              <option value="jump.lutz">{$_("sessions.form.iceTraining.techniques.jump.lutz")}</option>
              <option value="jump.axel">{$_("sessions.form.iceTraining.techniques.jump.axel")}</option>
              <option value="jump.combination">{$_("sessions.form.iceTraining.techniques.jump.combination")}</option>
            </optgroup>
            <optgroup label={$_("sessions.form.iceTraining.techniques.spin.title")}>
              <option value="spinn.upright">{$_("sessions.form.iceTraining.techniques.spin.standing")}</option>
              <option value="spinn.sit">{$_("sessions.form.iceTraining.techniques.spin.sitSpin")}</option>
              <option value="spinn.camel">{$_("sessions.form.iceTraining.techniques.spin.parallel")}</option>
              <option value="spinn.jump">{$_("sessions.form.iceTraining.techniques.spin.jumpParallel")}</option>
              <option value="spinn.layback">{$_("sessions.form.iceTraining.techniques.spin.bend")}</option>
              <option value="spinn.combination">{$_("sessions.form.iceTraining.techniques.spin.combination")}</option>
            </optgroup>
            <optgroup label={$_("sessions.form.iceTraining.techniques.competition.title")}>
              <option value="competition.shortProgram">{$_("sessions.form.iceTraining.techniques.competition.short")}</option>
              <option value="competition.freeProgram">{$_("sessions.form.iceTraining.techniques.competition.free")}</option>
              <option value="competition.otherCompetition"
                >{$_("sessions.form.iceTraining.techniques.competition.other")}</option
              >
            </optgroup>
            <optgroup label={$_("sessions.form.iceTraining.techniques.other.title")}>
              <option value="stepSequence">{$_("sessions.form.iceTraining.techniques.other.sequence")}</option>
              <option value="choreoSequence">{$_("sessions.form.iceTraining.techniques.other.corography")}</option
              >
              <option value="FigureSkating.TechniqueSteps">{$_("sessions.form.iceTraining.techniques.other.step")}</option>
              <option value="FigureSkating.flyer">{$_("sessions.form.iceTraining.techniques.other.flyer")}</option>
              <option value="FigureSkating.BaseTraining"
                >{$_("sessions.form.iceTraining.techniques.other.warmup")}</option
              >
            </optgroup>
            <optgroup label={$_("sessions.form.iceTraining.techniques.icePlay.title")}>
              <option value="general.game1">{$_("sessions.form.iceTraining.techniques.icePlay.skateGuard")}</option>
              <option value="general.game2">{$_("sessions.form.iceTraining.techniques.icePlay.other")}</option>
            </optgroup>
          </select>
        </span>
      </label>
      {#if element === "jump.combination" || element === "spinn.combination" || element === "stepSequence" || element === "choreoSequence" || element === "FigureSkating.TechniqueSteps" || element === "FigureSkating.BaseTraining" || element === "FigureSkating.flyer"}
        <label class="input" for="Utført element">
          <span class="input__label" style="white-space:nowrap">
            {element === "spinn.combination"
              ? $_("sessions.form.positions")
              : element === "FigureSkating.TechniqueSteps" ||
                  element === "FigureSkating.BaseTraining"
                ? $_("sessions.form.comment")
                : element === "stepSequence" || element === "choreoSequence"
                  ? $_("sessions.form.program")
                  : $_("sessions.form.element")}
          </span>
          <input
            class="input__text input__text--size-sm"
            inputmode="text"
            maxlength="60"
            name="distanse"
            id="distance"
            autocomplete="off"
            bind:value={content}
            style="width:100%"
          />
        </label>
      {/if}
      <div style="display: flex; justify-content: space-between; gap:10px">
        {#if levelElements.includes(element)}
          <div style="flex:1">
            <label class="select" for={$_("sessions.form.level")}>
              <span class="select__label">{$_("sessions.form.level")}</span>
              <div>
                <span class="select__button">
                  <select bind:value={level}>
                    {#if element.startsWith("spinn.")}
                      <option selected>B</option>
                    {/if}
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select>
                </span>
              </div>
            </label>
          </div>
        {/if}
        {#if !durationOnly.includes(element)}
          <div style="flex:1">
            <label class="input" for="Varighet (min)">
              <span class="input__label" style="white-space:nowrap">{$_("sessions.form.number")}</span
              >
              <input
                class="input__number input__number--size-sm"
                inputmode="numeric"
                maxlength="2"
                pattern="[0-9]*"
                name="distanse"
                id="distance"
                autocomplete="off"
                bind:value={repetitions}
                style="width:100%"
              />
            </label>
          </div>
          {#if !element.startsWith("competition")}
            <div style="flex:1">
              <label class="input" for="Varighet (min)">
                <span class="input__label" style="white-space:nowrap"
                  >{$_("sessions.form.successes")}</span
                >
                <input
                  class="input__number input__number--size-sm"
                  inputmode="numeric"
                  maxlength="2"
                  pattern="[0-9]*"
                  name="distanse"
                  id="distance"
                  autocomplete="off"
                  bind:value={successful}
                  style="width:100%"
                />
              </label>
            </div>
          {/if}
        {/if}
        <div style="flex:1">
          <label class="input" for="Varighet (min)">
            <span class="input__label" style="white-space:nowrap"
              >{$_("sessions.form.time")}</span
            >
            <input
              class="input__number input__number--size-sm"
              inputmode="numeric"
              maxlength="8"
              pattern="[0-9]*"
              name="distanse"
              id="distance"
              autocomplete="off"
              bind:value={duration}
              style={!durationOnly.includes(element) ? "width:100%" : ""}
            />
          </label>
        </div>
      </div>
    </div>
  </div>
{/if}
